module.exports = __webpack_public_path__ + "img/aaron-farr-circle.c2b534ec.png";